/**
 * WhatsApp's own glyph, in WhatsApp's own green.
 *
 * Deliberately NOT a Lucide outline icon tinted with a token: this is a
 * third-party brand mark, and a recognisable one is the entire reason it is
 * here. A traveller scanning a row of departures spots the green bubble before
 * they read anything, which is what makes it a usable escape hatch. Recoloured
 * to the tenant's brand it would just be another button.
 *
 * The two fills are literal hexes for the same reason `--surface-book` is a
 * fixed token: they are not ours to theme. Marked `aria-hidden` — every call
 * site labels the link itself, so the mark must not also announce.
 */
export function WhatsappMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 58 58" aria-hidden="true" className={className}>
      <path
        fill="#2CB742"
        d="M0,58l4.988-14.963C2.457,38.78,1,33.812,1,28.5C1,12.76,13.76,0,29.5,0S58,12.76,58,28.5S45.24,57,29.5,57c-4.789,0-9.299-1.187-13.26-3.273L0,58z"
      />
      {/*
       * The handset sits INSET in the bubble, scaled about the bubble's own
       * centre. At its drawn size it ran corner to corner and touched the
       * green edge on both diagonals, which is not how WhatsApp draws their
       * mark and read as a cramped icon rather than a familiar one.
       *
       * A transform rather than re-drawn path data: the geometry is WhatsApp's
       * and retracing it by hand is how a brand mark ends up subtly wrong.
       */}
      <path
        fill="#FFFFFF"
        transform="translate(29.5 28.75) scale(0.8) translate(-29.5 -28.75)"
        d="M47.683,37.985c-1.316-2.487-6.169-5.331-6.169-5.331c-1.098-0.626-2.423-0.696-3.049,0.42c0,0-1.577,1.891-1.978,2.163c-1.832,1.241-3.529,1.193-5.242-0.52l-3.981-3.981l-3.981-3.981c-1.713-1.713-1.761-3.41-0.52-5.242c0.272-0.401,2.163-1.978,2.163-1.978c1.116-0.627,1.046-1.951,0.42-3.049c0,0-2.844-4.853-5.331-6.169c-1.058-0.56-2.357-0.364-3.203,0.482l-1.758,1.758c-5.577,5.577-2.831,11.873,2.746,17.45l5.097,5.097l5.097,5.097c5.577,5.577,11.873,8.323,17.45,2.746l1.758-1.758C48.048,40.341,48.243,39.042,47.683,37.985z"
      />
    </svg>
  );
}
